import { useCallback, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { clearPublicNotesAction, getPublicNotesAction } from '../../redux/actions/notesActions';

const useFetchPublicNotes = () => {
  const dispatch = useDispatch();
  const search = useSelector((state) => state.notes?.publicNotesSearch);
  const publicNotes = useSelector((state) => state.notes?.publicNotes);
  const loading = useSelector((state) => state.notes?.publicNotesLoading);

  const fetchPublicNotes = useCallback(async () => {
    await dispatch(getPublicNotesAction(search));
  }, [dispatch, search]);

  useEffect(() => {
    fetchPublicNotes();
  }, [fetchPublicNotes]);

  useEffect(() => {
    return () => {
      dispatch(clearPublicNotesAction());
    };
  }, [dispatch]);

  const refresh = () => {
    fetchPublicNotes();
  };

  return { loading, publicNotes, refresh };
};

export default useFetchPublicNotes;
